import { Locale } from '@headless-workspace/config';
import { ThemeMode } from '@headless-workspace/core-ui';

type PlayerOptionsProps = {
    websiteId: string;
    widgets: {
        type: string;
        nodeId: string;
        productId: string;
        device: string;
        icon: string;
        chevron: null;
        direction: string;
        closedStateMainText: string;
        closedStateSecondaryText: string;
        closedStateDisplayChevron: boolean;
        scale: number;
        animation: string;
        placement: {
            top: string;
            right: string;
        };
        locale: Locale;
    }[];
    theme: {
        fontFamily: string;
        backgroundOutside: string;
        backgroundInside: string;
        iconColor: string;
        openStateTextColor: string;
        closedStateTextColor: string;
        closedStateMainTextSize: string;
        closedStateMainTextWeight: number;
        closedStateSecondaryTextSize: string;
        closedStateSecondaryTextWeight: number;
        borderColor: string;
        borderWidth: string;
        starsColor: string;
        playerShadow: boolean;
    };
};

const AUDIO_PLAYER_LIGHT_THEME = {
    fontFamily: 'AvantGardeMedium, Arial, sans-serif',
    backgroundOutside: '#000000',
    backgroundInside: '#000000',
    iconColor: '#FFFFFF',
    openStateTextColor: '#000000',
    closedStateTextColor: '#000000',
    closedStateMainTextSize: '14px',
    closedStateMainTextWeight: 700,
    closedStateSecondaryTextSize: '14px',
    closedStateSecondaryTextWeight: 500,
    borderColor: '#000000',
    borderWidth: '0px',
    starsColor: '#FECC4B',
    playerShadow: false,
};

const AUDIO_PLAYER_DARK_THEME = {
    fontFamily: 'AvantGardeMedium, Arial, sans-serif',
    backgroundOutside: '#000000',
    backgroundInside: 'white',
    iconColor: 'black',
    openStateTextColor: 'white',
    closedStateTextColor: 'white',
    closedStateMainTextSize: '14px',
    closedStateMainTextWeight: 700,
    closedStateSecondaryTextSize: '14px',
    closedStateSecondaryTextWeight: 500,
    borderColor: '#000000',
    borderWidth: '0px',
    starsColor: '#FECC4B',
    playerShadow: false,
};

export const PlayerOptions = (
    locale: Locale,
    audioContainerId: string,
    masterProductId: string,
    mainText: string,
    secondaryText: string,
    websiteId: string,
    themeMode: ThemeMode,
): PlayerOptionsProps => {
    return {
        websiteId,
        widgets: [
            {
                type: 'standalone',
                nodeId: audioContainerId,
                productId: masterProductId,
                device: 'all',
                icon: 'icon-play',
                chevron: null,
                direction: 'normal',
                closedStateMainText: mainText,
                closedStateSecondaryText: secondaryText,
                closedStateDisplayChevron: false,
                scale: 1,
                animation: 'null',
                placement: {
                    top: '0px',
                    right: '0px',
                },
                locale,
            },
        ],
        theme: themeMode === 'light' ? AUDIO_PLAYER_LIGHT_THEME : AUDIO_PLAYER_DARK_THEME,
    };
};
